import { createStyles } from '../../../../../../../../../styles/helpers'

const useStyles = createStyles({
  tableActions: {
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px'
  },
  addProductsBtn: {
    display: 'block',
    margin: '24px auto 16px'
  },
  toggleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    alignItems: 'center',
    marginRight: 'auto'
  }
})

export default useStyles
